import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { FORM_BUTTON_TYPES, FORM_FIELD_TYPES } from '@whitbread-eos/atoms';
import { formatDataTestId } from '@whitbread-eos/utils';
import ArrivalDate from './ArrivalDateInput/ArrivalDateInput.component';
import validateForm from './formValidation';
export var manageBookingFormConfig = _ref => {
  var _labels$headerInforma, _labels$headerInforma2, _labels$headerInforma3, _labels$headerInforma4, _labels$headerInforma5;
  var getFormState = _ref.getFormState,
    defaultValues = _ref.defaultValues,
    onSubmit = _ref.onSubmit,
    baseTestId = _ref.baseTestId,
    resetForm = _ref.resetForm,
    labels = _ref.labels,
    isSubmitDisabled = _ref.isSubmitDisabled;
  var _validateForm = validateForm(labels),
    formValidationSchema = _validateForm.formValidationSchema;
  var config = {
    id: 'manageBookingForm',
    elements: {
      fields: [{
        type: FORM_FIELD_TYPES.INPUT_TEXT,
        name: 'bookingReference',
        label: labels === null || labels === void 0 || (_labels$headerInforma = labels.headerInformation) === null || _labels$headerInforma === void 0 || (_labels$headerInforma = _labels$headerInforma.form) === null || _labels$headerInforma === void 0 ? void 0 : _labels$headerInforma.bookingReferenceLabel,
        testid: formatDataTestId(baseTestId, 'BookingReference'),
        styles: _objectSpread(_objectSpread({}, inputStyle), {}, {
          marginBottom: 'lg'
        }),
        props: {
          useTooltip: true,
          styles: placeholderStyles
        }
      }, {
        type: FORM_FIELD_TYPES.INPUT_TEXT,
        name: 'bookingSurname',
        label: labels === null || labels === void 0 || (_labels$headerInforma2 = labels.headerInformation) === null || _labels$headerInforma2 === void 0 || (_labels$headerInforma2 = _labels$headerInforma2.form) === null || _labels$headerInforma2 === void 0 ? void 0 : _labels$headerInforma2.bookingSurnameLabel,
        testid: formatDataTestId(baseTestId, 'BookingSurname'),
        styles: _objectSpread(_objectSpread({}, inputStyle), {}, {
          marginBottom: 'lg'
        }),
        props: {
          useTooltip: true,
          styles: placeholderStyles
        }
      }, {
        type: FORM_FIELD_TYPES.DYNAMIC_FIELD,
        name: 'arrivalDate',
        label: labels === null || labels === void 0 || (_labels$headerInforma3 = labels.headerInformation) === null || _labels$headerInforma3 === void 0 || (_labels$headerInforma3 = _labels$headerInforma3.form) === null || _labels$headerInforma3 === void 0 ? void 0 : _labels$headerInforma3.arrivalDateLabel,
        Component: ArrivalDate,
        props: {
          todayLabel: labels === null || labels === void 0 || (_labels$headerInforma4 = labels.headerInformation) === null || _labels$headerInforma4 === void 0 || (_labels$headerInforma4 = _labels$headerInforma4.content) === null || _labels$headerInforma4 === void 0 || (_labels$headerInforma4 = _labels$headerInforma4.global) === null || _labels$headerInforma4 === void 0 ? void 0 : _labels$headerInforma4.today,
          tomorrowLabel: labels === null || labels === void 0 || (_labels$headerInforma5 = labels.headerInformation) === null || _labels$headerInforma5 === void 0 || (_labels$headerInforma5 = _labels$headerInforma5.content) === null || _labels$headerInforma5 === void 0 || (_labels$headerInforma5 = _labels$headerInforma5.global) === null || _labels$headerInforma5 === void 0 ? void 0 : _labels$headerInforma5.tomorrow
        },
        testid: formatDataTestId(baseTestId, 'ArrivalDate'),
        styles: inputStyle
      }],
      buttons: [{
        type: FORM_BUTTON_TYPES.SUBMIT,
        label: 'Search',
        action: onSubmit,
        props: {
          variant: 'primary',
          size: 'full',
          disabled: isSubmitDisabled
        },
        styles: _objectSpread({}, searchButton),
        testid: formatDataTestId(baseTestId, 'Search')
      }]
    },
    defaultValues,
    validationSchema: formValidationSchema,
    getFormState,
    resetForm
  };
  return config;
};
var placeholderStyles = {
  inputElementStyles: {
    _placeholder: {
      fontStyle: 'normal',
      color: 'var(--chakra-colors-chakra-subtle-text)'
    }
  }
};
var searchButton = {
  mb: 0
};
var inputStyle = {
  width: {
    mobile: '18rem',
    xs: '21.5rem',
    lg: '24.5rem',
    xl: '26.25rem'
  }
};